export const blogData = [
  {
    title: "What is a Network Effect?",
    description:
      "Network effects play a significant role in the cryptocurrency ecosystem. For example, if new users join a particular blockchain network in large numbers, the underlying service likely offers more utility.",
    imageUrl: "/images/pic1.webp",
    publishDate: "May 17, 2021",
    avatar: "/images/avatar.png",
    authorName: "Anshu Raj",
    tags: ["#network ", "#Effect"],
  },
  {
    title: "What is Polkadot (DOT)?",
    description:
      "Polkadot is a blockchain protocol that connects multiple specialized chains into a single universal network.Blockchain is undoubtedly a ground-breaking technology that powers the entire cryptocurrency ecosystem, including Decentralized Finance.",
    imageUrl: "/images/pic2.webp",
    publishDate: "May 9, 2021",
    avatar: "/images/avatar.png",
    authorName: "Anshu Raj",
    tags: ["#Polkadot ", "#DOT"],
  },
  {
    title: "An introduction to NFTs",
    description:
      "Before discussing what NFTs are and how they work, let's first understand the difference between the terms 'fungible' and 'non-fungible.'Fungible assets are mutually interchangeable and can be replaced by another identical asset. For example, Bitcoin, Ethereum, or even traditional money are fungible",
    imageUrl: "/images/pic3.webp",
    publishDate: "May 7, 2021",
    avatar: "/images/avatar.png",
    authorName: "Anshu Raj",
    tags: ["#NFTs ", "#assets"],
  },
];
